import {SAVE_CONFIGURATION} from "../actions/saveConfiguration";

export default (previousState = [], action) => {
  switch (action.type) {
    case SAVE_CONFIGURATION: {
      return action.payload;
    }

    default:
      return previousState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/configuration.js